import { enUS, frFR, deDE, itIT, ptPT, esES } from '@mui/material/locale';

import { PATH_DASHBOARD } from './routes/paths';

//
// API

export const HOST_API = process.env.REACT_APP_HOST_API_KEY || '';
export const API_URL = process.env.REACT_APP_API_URL;
export const BASE_URL = process.env.REACT_APP_BASE_URL || '';
export const BASE_DOMAIN = process.env.REACT_APP_BASE_DOMAIN;
export const API_KEY:string = process.env.REACT_APP_CARBON_APP_API_KEY as string;
export const STRIPE_CUSTOMER_PORTAL_LINK: string | null = process.env.REACT_APP_STRIPE_CUSTOMER_PORTAL_LINK as string;
export const STRIPE_PRICING_TABLE_ID: string | null = process.env.REACT_APP_STRIPE_PRICING_TABLE_ID as string;
export const STRIPE_PUBLISHABLE_KEY: string = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY as string;

export const SENTRY_DSN:string = process.env.REACT_APP_SENTRY_DSN as string;
export const ENVIRONMENT_NAME:string = process.env.REACT_APP_CI_ENVIRONMENT_NAME as string;
export const IMPACT_BASE_URL:string = process.env.REACT_APP_IMPACT_BASE_URL as string;
export const MYCC_BASE_URL:string = process.env.REACT_APP_MY_CC_URL as string;
export const JOURNEY_CALCULATOR_BASE_URL:string = process.env.REACT_APP_JOURNEY_CALCULATOR_BASE_URL as string;
export const ACTIVITY_CALCULATOR_BASE_URL:string = process.env.REACT_APP_ACTIVITY_CALCULATOR_BASE_URL as string;
export const CONTRIBUTION_WIDGET_BASE_URL:string = process.env.REACT_APP_CONTRIBUTION_WIDGET_BASE_URL as string;
export const DRIVING_CALCULATOR_MYCC_SUB_PATH:string = process.env.REACT_APP_DRIVING_CALCULATOR_MYCC_SUB_PATH as string;
export const PURCHASE_OFFSET_MYCC_SUB_PATH:string = process.env.REACT_APP_PURCHASE_OFFSET_MYCC_SUB_PATH as string;
export const CARBON_TILE_BASE_URL:string = process.env.REACT_APP_CARBON_TILE_BASE_URL as string;
export const FLIGHT_CALCULATOR_BASE_URL:string = process.env.REACT_APP_FLIGHT_CALCULATOR_BASE_URL as string;
export const MUI_LICENSE_KEY: string = process.env.REACT_APP_MUI_LICENSE_KEY as string;

export const SEMVER:string = process.env.REACT_APP_SEMVER || "0.0.0";
export const BUSINESS_CALCULATOR_URL:string = process.env.REACT_APP_BUSINESS_CALCULATOR_URL as string;


export const COGNITO_API = {
  userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
  clientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID,
};

export const MAPBOX_API = process.env.REACT_APP_MAPBOX_API;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = PATH_DASHBOARD.general.app; // as '/dashboard/app'

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  MOBILE_HEIGHT: 80,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_HEIGHT: 80,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32,
};

export const NAVBAR = {
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 280,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  //
  DASHBOARD_ITEM_ROOT_HEIGHT: 32,
  DASHBOARD_TITLE_ROOT_HEIGHT: 84,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
};

export const ICON = {
  NAVBAR_ITEM: 28,
  NAVBAR_ITEM_HORIZONTAL: 20,
};

// SETTINGS
// Please remove `localStorage` when you change settings.
// ----------------------------------------------------------------------

export const defaultSettings = {
  themeMode: 'light',
  themeDirection: 'ltr',
  themeContrast: 'default',
  themeLayout: 'horizontal',
  themeColorPresets: 'default',
  themeStretch: false,
};

// MULTI LANGUAGES
// Please remove `localStorage` when you change settings.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: 'English',
    value: 'en',
    systemValue: enUS,
    icon: '/assets/icons/flags/ic_flag_en.svg',
  },
  {
    label: 'Español',
    value: 'es',
    systemValue: esES,
    icon: '/assets/icons/flags/ic_flag_sa.svg',
  },
  {
    label: 'Français',
    value: 'fr',
    systemValue: frFR,
    icon: '/assets/icons/flags/ic_flag_fr.svg',
  },
  {
    label: 'Deutsch',
    value: 'de',
    systemValue: deDE,
    icon: '/assets/icons/flags/ic_flag_sa.svg',
  },
  {
    label: 'Italiano',
    value: 'it',
    systemValue: itIT,
    icon: '/assets/icons/flags/ic_flag_sa.svg',
  },
  {
    label: 'Português',
    value: 'pt',
    systemValue: ptPT,
    icon: '/assets/icons/flags/ic_flag_sa.svg',
  },
];

export const defaultLang = allLangs[0]; // English
